import angular from 'angular';

import appContainer from './containers/app.container';
import rootContainer from './containers/root.container';
import routerContainer from './containers/router.container';
import app from './components/app/app.component';
import router from './components/router/router.component';
import locationProviderConfig from './configs/locationProvider.config';

/**
 * This is the root module of the application; It setups de base settings, styles and structure
 * the other modules will use to show their components/containers.
 * @ngesdoc module
 * @ngname root
 */
const rootModule = angular.module('root', [])
.component('appContainer', appContainer)
.component('rootContainer', rootContainer)
.component('routerContainer', routerContainer)
.component('app', app)
.component('router', router)
.config(locationProviderConfig);

export default rootModule.name;
